module.exports = __webpack_public_path__ + "img/story-mode-long.c49b1a6a.svg";